import { Link } from "react-router-dom";
import styles from './style.module.scss'
import { memo } from "react";
import useMainPath from "@shared/hooks/router/useMainPath";
import { usePerfilesContext } from "@conductor/context/PerfilesContext";
import perfiles from "@conductor/context/perfiles";
import IconNotify from "./IconNotify";


const NavBar = ({ setSidevbarActive, active }) => {
	const mainPath = useMainPath();
	const { perfil } = usePerfilesContext();

	// Orden visual de los tabs. El "activo" se resuelve por la ruta actual (mainPath),
	// así el highlight queda SIEMPRE sobre el ícono correcto — sin cálculos de píxeles.
	const linksTotal = {
		[perfiles.CHOFER]: [
			{ to: '/', src: 'bi bi-house-fill', callback: () => { setSidevbarActive(false) } },
			{ to: '/historico-chofer', src: 'bi bi-clock-history', callback: () => { setSidevbarActive(false) } },
			{ to: '/notificaciones', custon: IconNotify, callback: () => { setSidevbarActive(false) } },
			{ to: '/mapa-chofer', src: 'bi bi-geo-alt-fill', callback: () => { setSidevbarActive(false) } },
			{ src: 'bi bi-person-circle', callback: () => { setSidevbarActive(true) } },
		],
	};
	const links = linksTotal[perfil] || [];

	return (
		<nav className={`${styles.navbarLayout} ${active ? '' : styles.navbarLayoutDiseable}`}>
			<ul className={styles['navbarLayout-list']}>
				{links.map(({ to, src, callback, custon }, index) => {
					const isActive = to ? to === mainPath : false;
					if (custon) return custon({ to, isActive, callback, key: index });
					return (
						<li
							onClick={() => { if (callback) callback(); }}
							key={`${index}-${to || '#'}`}
							className={`${styles.item} ${isActive ? styles.itemActive : ''}`}
						>
							<Link to={to ? to : '#'} className={styles.link}>
								<i className={`${styles.icon} ${src}`} />
							</Link>
						</li>
					);
				})}
			</ul>
		</nav>
	);
};


export default memo(NavBar);
